import React from "react";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import { setOpen } from "../../../stateManagement/actions/claims";
import "./StockAdjustRejectionModal.css";

interface ModalProps {
  heading: string;
}

const StockAdjustRejectionModal = ({ heading }: ModalProps) => {
  const { open, selectedRowToEdit: selectedRow } = useSelector((state: any) => state.claims);
  const dispatch = useDispatch();

  const handleOnClose = () => {
    dispatch(setOpen(false));
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleOnClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="rejection_modal">
          <IconButton
            sx={{
              position: "absolute",
              top: "10px",
              right: "16px",
            }}
            onClick={handleOnClose}
          >
            <CloseIcon />
          </IconButton>

          <div className="rejection_modal_heading">{selectedRow?.batchId ?? heading}</div>

          <div className="rejection_modal_sub_heading">Reason for Rejection</div>

          <div className="rejection_modal_container">
            <div className="rejection_modal_text">
              The product is currently undergoing a review due to identified discrepancies or
              issues, which has resulted in a temporary restriction on any manual stock adjustments.
              This measure is in place to prevent further complications and ensure accurate
              resolution of the discrepancies. Once the review is complete and the issues are
              addressed, adjustments can be made accordingly. We appreciate your understanding and
              cooperation during this process.
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default StockAdjustRejectionModal;
